import { makeStyles } from '@mui/styles';

export const useDeliveriesRequiringAttentionTooltipStyles = makeStyles({
  tooltip: {
    backgroundColor: 'transparent',
    padding: 0,
    margin: 0
  }
});
